import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { MotiView } from 'moti';
import { memo } from 'react';
import { ViewProps } from 'react-native';

export const ListItemCheckmark = memo(
  ({
    checked,
    iconSize,
    iconColor,
    ...props
  }: {
    checked?: boolean;
    iconSize?: number;
    iconColor?: string;
  } & ViewProps) => {
    const { rpx } = useResponsiveContext();
    if (!checked) return null;
    return (
      <MotiView
        from={{ opacity: 0 }}
        exit={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        css={`
          flex-shrink: 0;
          flex-grow: 0;
        `}
        {...props}
      >
        <Icon
          name="check"
          size={iconSize ?? rpx(24)}
          color={iconColor ?? 'black'}
        />
      </MotiView>
    );
  },
);
